import { z } from 'zod'

export const paymentSchema = z.object({
  client_id: z.string().uuid(),
  customer_id: z.string().uuid(),
  amount: z.number().positive(),
  payment_date: z.string(),
  payment_method: z.enum(['check', 'ach', 'wire', 'credit_card', 'cash', 'other']),
  applied_to_baseline: z.boolean(),
  notes: z.string().optional().nullable(),
})

export type PaymentInput = z.infer<typeof paymentSchema>
export type PaymentFormData = z.infer<typeof paymentSchema>
